export const constructionSiteSubmissionQueryKeys = {
	all: ["construction-site-submission"] as const,
	details: () =>
		[...constructionSiteSubmissionQueryKeys.all, "details"] as const,
	detail: (constructionSiteId: number) =>
		[
			...constructionSiteSubmissionQueryKeys.details(),
			constructionSiteId,
		] as const,
	operation: (constructionSiteId: number) =>
		[
			...constructionSiteSubmissionQueryKeys.detail(constructionSiteId),
			"operation",
		] as const,
	participants: (constructionSiteId: number) =>
		[
			...constructionSiteSubmissionQueryKeys.detail(constructionSiteId),
			"participants",
		] as const,
	participant: (constructionSiteId: number, participantId: number) =>
		[
			...constructionSiteSubmissionQueryKeys.participants(constructionSiteId),
			"participant",
			participantId,
		] as const,
	referenceableFiles: (constructionSiteId: number) =>
		[
			...constructionSiteSubmissionQueryKeys.detail(constructionSiteId),
			"referenceable-files",
		] as const,
	binderWarrantiesTypesSelected: (constructionSiteId: number) =>
		[
			...constructionSiteSubmissionQueryKeys.detail(constructionSiteId),
			"binder-warranties-types-selected",
		] as const,
	participantsReception: (constructionSiteId: number) =>
		[
			...constructionSiteSubmissionQueryKeys.detail(constructionSiteId),
			"participants-reception",
		] as const,
};
